module.exports = __webpack_public_path__ + "static/media/ChunkFive-Regular.2d5c612e.otf";